// @needsAudit
/**
 * Type representing canceled pick result.
 */ export { };

//# sourceMappingURL=types.js.map
